import './SignInWithAppleButton.css';
import appleLogo from "../../assets/apple-logo.svg";
import {isSafari} from "../../lib/helpers/browserHelper.ts";
import {
    signInWithAppleLibrary,
    signInWithFirebasePopUp
} from "../../lib/helpers/signInHelper.ts";
import { captureMessage } from "../../lib/sentry";


function SignInWithAppleButton() {

    const handleAppleSignIn = async () => {
        try {
            if (!isSafari()) {
                await signInWithFirebasePopUp();
            } else {
                await signInWithAppleLibrary();
            }
        } catch (error) {
            captureMessage(`SignInWithAppleButton: ${error}`);
        }
    }

    return (
        <button
            className="apple-sign-in-button body-md semibold"
            onClick={handleAppleSignIn}
            aria-label="Sign in with Apple">

            <img className="apple-logo" src={appleLogo} alt="apple logo"/>
            Sign up with Apple
        </button>
    )
}

export default SignInWithAppleButton
